<template>
  <div>
    <b-message type="is-warning" v-if="results !== null && results.length === 0">
      Keine Ergebnisse gefunden.
    </b-message>
    <b-message type="is-danger" v-if="error !== null">
      <strong>Fehler: </strong><pre style="white-space:pre-wrap">{{ error }}</pre>
    </b-message>
    <b-table v-if="results !== null && results.length > 0" :data="results" :columns="columns" />
  </div>
</template>

<script>
export default {
  props: ['db', 'sql', 'autoexec'],
  data () {
    return {
      columns: null,
      results: null,
      error: null
    }
  },
  computed: {
  },
  methods: {
    execute() {
      this.error = null
      try {
         this.results = this.db.exec(this.sql)
      } catch(e) {
         this.error = e + ''
         this.results = null
         return
      }
      let columns = [];
      let row = this.results[0];
      for (let key in row) {
        if (row.hasOwnProperty(key)) {
          columns.push({
            field: key,
            label: key
          })
        }
      }
      this.columns = columns;
    }
  },
  mounted: function() {
    if (this.autoexec) {
      this.execute()
    }
  }
}
</script>
